import React from 'react';
import { Incident } from '../../pages/law/incidentsData';
import { MetricCard } from '../ui/MetricCard';

type IncidentStatsProps = {
  incidents: Incident[];
};

export function IncidentStats({ incidents }: IncidentStatsProps) {
  return (
    <section className="stat-grid incident-stat-grid">
      <MetricCard
        color="red"
        delta="+1"
        icon="alert"
        label="Active incidents"
        value={incidents.filter((incident) => incident.status === 'active').length.toString()}
      />
      <MetricCard
        color="gold"
        delta="0"
        icon="shield"
        label="Acknowledged"
        value={incidents.filter((incident) => incident.status === 'acknowledged').length.toString()}
      />
      <MetricCard
        color="green"
        delta="+2"
        icon="activity"
        label="Resolved today"
        value={incidents.filter((incident) => incident.status === 'resolved').length.toString()}
      />
    </section>
  );
}
